/**
 * CriticalStateBadge — the one badge that draws a §14C.1 critical-state distinction
 * (FULL-0155 / PROD-UX-069).
 *
 * It keeps information, recommendation, warning, approval-required, approved, destructive, blocked,
 * verified, unknown and no-permission visually and semantically apart. The shell is the canonical
 * `statusVocabulary.CHIP_CLS`; the tone comes from `styles/designTokens.css`, whose values are
 * asserted equal to the canonical statusVocabulary arm named by `toneOwner`.
 *
 * The badge is presentation only: it never changes a status, approves anything or claims an
 * authority. An unknown key falls back to the explicit `unknown` badge rather than guessing a more
 * specific state. Direction is inherited — the badge carries Hebrew text and must stay inside the
 * reading direction of the surface that mounts it.
 */
import { CHIP_CLS } from "../statusVocabulary";
import { criticalStateMeta } from "./designTokens";

export default function CriticalStateBadge({
  state = "unknown",
  label = null,
  testId,
  className = "",
}) {
  const meta = criticalStateMeta(state);
  return (
    <span
      className={`${CHIP_CLS} prodigy-critical-badge${className ? ` ${className}` : ""}`}
      data-critical-state={meta.key}
      data-tone-owner={meta.toneOwner || undefined}
      data-testid={testId}
      title={meta.meaning}
    >
      {label || meta.label}
    </span>
  );
}
